/**
 * SHAH Service
 * Service layer for SHAH web portal chatbot operations
 */

import apiService from '../../../services/apiService';

// Utility functions
export const formatDate = (isoString) => {
  if (!isoString) return '';
  const date = new Date(isoString);
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatCurrency = (value) => {
  if (value == null || value === '') return null;
  const numericValue = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(numericValue)) return null;
  return `${numericValue.toFixed(2)}`;
};

export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength - 3) + '...';
};

const ShahService = {
  formatDate,
  formatCurrency,
  truncateText,

  /**
   * Sends a user message to queue a chat job in DynamoDB
   */
  async sendChatMessage(message, sessionId, visitorInfo = {}) {
    try {
      const response = await apiService.post('/shah/chat', {
        message,
        session_id: sessionId,
        visitor_info: visitorInfo
      });
      return response;
    } catch (error) {
      console.error('Error in sendChatMessage:', error);
      throw error;
    }
  },

  /**
   * Polls the job status to see if the SHAH worker has replied
   */
  async pollChatResponse(sessionId, jobId) {
    try {
      const response = await apiService.get(`/shah/chat/poll/${sessionId}/${jobId}`);
      return response;
    } catch (error) {
      console.error('Error in pollChatResponse:', error);
      throw error;
    }
  },

  /**
   * Checks health and worker status
   */
  async getHealth() {
    try {
      const response = await apiService.get('/shah/health');
      return response;
    } catch (error) {
      console.error('Error in getHealth:', error);
      throw error;
    }
  }
};

export default ShahService;
